// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__2GGe0","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__K1-Yy"};